<!-- App Root Component -->
<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useUiStore } from '@/stores/ui'
import { useTheme } from '@/composables/useTheme'
import MainLayout from '@/components/layout/MainLayout.vue'
import ToastProvider from '@/components/ui/ToastProvider.vue'

const authStore = useAuthStore()
const uiStore = useUiStore()
const { initTheme } = useTheme()

onMounted(() => {
  initTheme()
  authStore.initAuth()
})

// Global keyboard shortcuts
function handleKeydown(event: KeyboardEvent) {
  // Escape to close modals
  if (event.key === 'Escape') {
    uiStore.closeAllModals()
  }
}

document.addEventListener('keydown', handleKeydown)
</script>

<template>
  <div class="app">
    <MainLayout>
      <RouterView />
    </MainLayout>
    <!-- Global Toasts via ToastProvider -->
    <ToastProvider />
  </div>
</template>

<style scoped>
.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>